import {
    START_ADD_AUDIT_DOCUEMNT_REGISTER,
    ADD_AUDIT_DOCUMENT_REGISTER_FAILED,
    ADD_AUDIT_DOCUMENT_REGISTER_SUCCESS,
    FETCH_AUDIT_DOCUMENT_REGISTER_START,
    FETCH_AUDIT_DOCUMENT_REGISTER_SUCCESS,
    FETCH_AUDIT_DOCUMENT_REGISTER_FAILED,
} from "./types";
import axios from "axios";
import { BaseUrl } from "./api";

export const fetchDocumentRegisterList = (token) => {
    return async (dispatch) => {
        dispatch({
            type: FETCH_AUDIT_DOCUMENT_REGISTER_START,
        });
        try {
            const res = await axios.get(`${BaseUrl}/audit_document_register`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.data.status) {
                dispatch({
                    type: FETCH_AUDIT_DOCUMENT_REGISTER_SUCCESS,
                    payload: res.data["audit_document_register"],
                });
            } else {
                dispatch({
                    type: FETCH_AUDIT_DOCUMENT_REGISTER_FAILED,
                    payload: res.data.message,
                });
            }
        } catch (error) {
            dispatch({
                type: FETCH_AUDIT_DOCUMENT_REGISTER_FAILED,
                payload: error.message,
            });
        }
    };
};

export const addAuditDocumentegister = (data, token) => {
    return async (dispatch) => {
        dispatch({
            type: START_ADD_AUDIT_DOCUEMNT_REGISTER,
        });
        try {
            const res = await axios.post(
                `${BaseUrl}/audit_document_register`,
                { audit_document: data },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        dataType: "json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (res.data.status) {
                dispatch({
                    type: ADD_AUDIT_DOCUMENT_REGISTER_SUCCESS,
                    payload: res.data.message,
                });
            } else {
                dispatch({
                    type: ADD_AUDIT_DOCUMENT_REGISTER_FAILED,
                    payload: res.data.message,
                });
            }
        } catch (error) {
            dispatch({
                type: ADD_AUDIT_DOCUMENT_REGISTER_FAILED,
                payload: error.message,
            });
        }
    };
};
